(() => {
  const init = () => {
    document.querySelectorAll('.button, .ima-service-card__cta').forEach((el) => {
      el.addEventListener('pointerdown', () => el.classList.add('ima-clicked'), { passive: true });
      el.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') el.classList.add('ima-clicked');
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
